var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import moment from "moment";
import React, { useCallback, useContext, useEffect, useLayoutEffect, useRef, useState, } from "react";
import { OverviewDashboardContext } from "src/contexts/custom-context";
import { captureCleverTabAnalytics } from "src/utils/analytics";
import { TAB_CHANGE_REFRESH_TIME } from "src/utils/constant";
import BuyButton from "../../../components/buttons/buy/buy";
import SellButton from "../../../components/buttons/sell/sell";
import { ThemeContext } from "../../../contexts/theme-context";
const { REACT_APP_URL_ASSET_BASE_PATH, REACT_APP_URL_CHART, REACT_APP_ENV } = process.env;
// import { setPreferences } from "src/apis/dashboard";
import CommonLtpRenderer from "src/components/ltp-renderer/common-ltp-renderer";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import { onModalOpenClose, openAddToWatchlistModal, openBuySellModal, openGuestLoginModal, } from "../../../redux/reducers/modals";
import { getChartUrl, getDefaultDateFormat, getEnvironmentVariableOrEmpty, getPreferences, getSegmentAndProductType, setPreferences, } from "../../../utils/methods";
import { unsubscribeDataBySubscriber } from "../../../utils/websocketwrapper";
import IndicatorWidget from "../indicator-widget/indicator-widget";
import OverviewDetails from "./overview-details";
import styles from "./overview.module.scss";
import { useNavigate } from "react-router";
import { createSearchParams } from "react-router-dom";
import { stockInfoData } from "src/redux/reducers/stock-info-Reducer";
import Loader from "src/components/loader/loader";
import Backfill from "src/components/backfill/backfill";
import { getIndexPCR } from "src/apis/dashboard";
// ref forwarding needed here
// For understanding - https://github.com/react-grid-layout/react-grid-layout/issues/1241#issuecomment-859651584
const componentName = "Overview";
const Overview = React.forwardRef((_a, ref) => {
    var { id, name, spotToken, symbol, scripCode, expiry, exch, exchType, indicatorWidgetSymbol, prevClose, lastRate, iframeLoader, iframeError, indexPCR } = _a, others = __rest(_a, ["id", "name", "spotToken", "symbol", "scripCode", "expiry", "exch", "exchType", "indicatorWidgetSymbol", "prevClose", "lastRate", "iframeLoader", "iframeError", "indexPCR"]);
    let toggleDataChart = false;
    const myPreference = getPreferences();
    if (spotToken > 0 && myPreference.dashboard.overview) {
        toggleDataChart =
            myPreference.dashboard.overview[spotToken + ""].showChart;
    }
    //const [indexPCRBank, setIndexPCRBank]: any = useState();
    const [showChart, setShowChart] = useState(toggleDataChart);
    const blurTime = useAppSelector((state) => state.app.windowBlurTime);
    const [counter, setCounter] = useState(0);
    const [chartTypeData, setChartTypeData] = useState("Area");
    const [infoType, setInfoType] = useState(toggleDataChart ? "chart" : "data");
    // const [indexPCR, setIndexPCR]: any = useState();
    //added for theming the chart using context api
    const { theme } = useContext(ThemeContext);
    //const prefValue = myPreference.dashboard.overview[spotToken + ""].showChart;
    const scripObject = useRef(undefined);
    // FIREBASE SHOW/HIDE CHARTS DATA VARIABLE FROM REDUX
    const showIframe = useAppSelector((state) => state.commonReducer.disableChartsIframe);
    const setScripObject = (a) => {
        scripObject.current = a;
    };
    const dispatch = useAppDispatch();
    const getShowChartFromPref = () => {
        if (myPreference.dashboard.overview == undefined) {
            return true;
        }
        else if (spotToken > 0) {
            let prefValue = myPreference.dashboard.overview[spotToken + ""];
            if (prefValue == undefined) {
                prefValue = { showChart: true };
                myPreference.dashboard.overview[spotToken + ""] = prefValue;
                setPreferences(myPreference);
            }
            return prefValue.showChart;
        }
        else {
            return true;
        }
    };
    // const url = `https://tradechart.5paisa.com/index.html?type=overview&period=1&exchange=nse&exchType=D&range=d&symbol=${symbol}&scripCode=${scripCode}&appName=5Paisa&appVer=5.11.6.0&osName=Windows&loginId=0&theme=Light&source=derivative&chartType=${chartTypeData}`;
    const getUrl = useCallback(() => {
        const localExpiry = moment(expiry).format("DD MMM YY");
        // getScripType(singleData.fullName, singleData.exchange, singleData.exchType);
        const chartData = {
            fullName: name.split(" ")[0] + " " + localExpiry,
            strikePrice: undefined,
            exchange: exch,
            exchangeType: exchType,
            expiry: localExpiry,
            symbol: name.split(" ")[0],
            scripCode: scripCode,
            theme: theme,
        };
        // console.log(isWindowFocused, " Chart get rerender");
        return getChartUrl(chartData, `${getEnvironmentVariableOrEmpty(REACT_APP_URL_CHART)}/LWDerivative/index.html?chartType=${chartTypeData}&counter=${counter}&`);
    }, [
        expiry,
        name,
        exch,
        exchType,
        scripCode,
        chartTypeData,
        theme,
        counter,
    ]);
    // console.log("url", getUrl())
    useEffect(() => {
        if (showChart) {
            // if (iframeRef && iframeRef.current != null) {
            //   //only for testing
            //   // iframeRef.current.onload = (event) => {
            //   //   console.log("Iframe url loaded");
            //   // };
            // }
            if (blurTime >= TAB_CHANGE_REFRESH_TIME) {
                setCounter(counter + 1);
            }
        }
    }, [showChart, blurTime]);
    useEffect(() => {
        if (myPreference.dashboard.overview != undefined &&
            myPreference.dashboard.overview[spotToken + ""] != undefined) {
            myPreference.dashboard.overview[spotToken + ""] = {
                showChart: showChart,
            };
        }
        setPreferences(myPreference);
    }, [showChart]);
    useLayoutEffect(() => {
        setShowChart(getShowChartFromPref());
    }, [spotToken]);
    const onChangeShowmore = () => {
        setShowChart(!showChart);
        captureCleverTabAnalytics(`${name} - ${!showChart ? "Hide" : "Show"} data button clicked`, {
            eventName: `${name} - ${!showChart ? "Hide" : "Show"} data button clicked`,
        });
    };
    const onAddToWatchlist = useCallback(() => {
        const payload = {
            Exch: exch,
            ExchType: exchType,
            ScripCode: scripCode,
            name: name,
        };
        dispatch(openAddToWatchlistModal(payload));
        dispatch(onModalOpenClose({ componentName: "watchlistModal", currState: "open" }));
    }, [scripCode, dispatch]);
    // function triggerDate(value: string): string {
    //   let a = value;
    //   a = a.substring(6, 19);
    //   const c = Number(a);
    //   const d = new Date(c);
    //   const e = d.toString();
    //   const date = e.substring(8, 10);
    //   const month = e.substring(4, 7).toUpperCase();
    //   const year = e.substring(11, 15);
    //   const finalValue = month + " " + date + year;
    //   return finalValue;
    // }
    const date = (indexPCR === null || indexPCR === void 0 ? void 0 : indexPCR.expdate) || expiry;
    const FullName = `${name} ${getSegmentAndProductType(symbol, exch, exchType).subProductType}`;
    const buySellCallBack = (isBuy, isBas) => {
        const data = {
            isBuy,
            name: name.toUpperCase() + " " + getDefaultDateFormat(date),
            exchange: exch,
            exchangeType: exchType,
            scripCode: scripCode,
            lastTradePrice: scripObject.current
                ? scripObject.current.lastRate
                : lastRate || 0,
            previousClose: scripObject.current
                ? scripObject.current.prevClose
                : prevClose || 0,
            // lastTradePrice: scripPriceData.LastRate,
            // previousClose: scripPriceData.PClose,
            orderFor: "P",
            isBasket: isBas,
            // orderData: { NetQty: 0 },
            orderData: undefined,
            netPositionDetail: undefined,
            vttOrderDetail: undefined,
            openedFrom: name,
            lotSize: (indexPCR === null || indexPCR === void 0 ? void 0 : indexPCR.marketlot) || 0,
        };
        if (isBas) {
            captureCleverTabAnalytics("Basket_Click", {
                Action: "Basket_Icon",
                Initiation_Screen: " Overview_" + name,
            });
        }
        dispatch(openBuySellModal(data));
    };
    const fetchIndexPCR = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const resultFromIndexPCR = yield getIndexPCR(name.split(" ")[0].toLowerCase());
            // setIndexPCR(
            //   resultFromIndexPCR?.data.response?.data?.companylist?.company
            // );
            //dummy response for dev testing
            // const resultFromIndexPCR: any = getIndexPCRResponse();
            // setIndexPCR(
            //   resultFromIndexPCR?.response?.data?.companylist?.company
            // );
        }
        catch (err) {
            console.error(err);
        }
    });
    // useEffect(() => {
    //   fetchIndexPCR();
    // }, []);
    //unmount effect
    useEffect(() => {
        return () => {
            //unmount call here
            unsubscribeDataBySubscriber(componentName);
        };
    }, []);
    const commonLtpRenderCallBack = useCallback((ltp, prevClose, changePercentObj) => {
        return (_jsxs("div", { children: [_jsx("span", Object.assign({ className: "mediumWeight large" }, { children: ltp })), _jsxs("div", Object.assign({ className: `${changePercentObj.isNegative
                        ? styles.negativeColor
                        : styles.positiveColor} ms-2` }, { children: [_jsxs("span", Object.assign({ className: `mediumWeight large me-2}` }, { children: [changePercentObj.differenceValue
                                    ? changePercentObj.differenceValue
                                    : `-`, " ", "(", changePercentObj.differencePercentage
                                    ? changePercentObj.differencePercentage
                                    : `-`, ")"] })), _jsx("span", { className: `${changePercentObj.isNegative
                                ? styles.redArrow
                                : styles.greenArrow} ms-1` })] }))] }));
    }, []);
    const toogleDataChart = (showchart, toggleType) => {
        setInfoType(toggleType);
        setShowChart(showchart);
        // onChangeShowmore();
        if (myPreference.dashboard.overview == undefined) {
            return;
        }
        else if (spotToken > 0) {
            let prefValue = myPreference.dashboard.overview[spotToken + ""];
            if (prefValue == undefined) {
                prefValue = { showChart: showchart };
                myPreference.dashboard.overview[spotToken + ""] = prefValue;
                setPreferences(myPreference);
            }
        }
        captureCleverTabAnalytics(`Overview page toggle button clicked`, {
            eventName: `${name} - ${toggleType}  toggle button clicked`,
        });
    };
    const navigate = useNavigate();
    const stockInfoPage = () => {
        const data = {
            symbol: name.toUpperCase() + " " + getDefaultDateFormat(expiry),
            exchange: exch,
            exchangeType: exchType,
            scripCode: scripCode,
            lastTradePrice: scripObject.current
                ? scripObject.current.lastRate
                : lastRate || 0,
            previousClose: scripObject.current
                ? scripObject.current.prevClose
                : prevClose || 0,
            expiry: "",
            StrikeRate: "",
            indexId: "-1",
        };
        const params = data;
        navigate({
            pathname: "/stock-info",
            search: `?${createSearchParams(params)}`,
        });
        dispatch(stockInfoData(data));
    };
    return (_jsx(OverviewDashboardContext.Provider, Object.assign({ value: {
            scripObject: scripObject.current,
            setScripObject: setScripObject,
        } }, { children: _jsx("div", Object.assign({ ref: ref }, others, { children: _jsxs("div", Object.assign({ className: `${styles.fiiContainer} ${styles.overviewSec} posRel` }, { children: [_jsxs("div", Object.assign({ className: styles.sectionHeader }, { children: [_jsx("span", Object.assign({ className: `${styles.sectionTitle} mediumWeight text-uppercase`, onDoubleClick: () => stockInfoPage() }, { children: FullName })), _jsxs("div", Object.assign({ className: `${styles.actionMenu} pointer` }, { children: [_jsx("span", { className: "watchlistIconBlue", onClick: () => dispatch(openGuestLoginModal()), title: "Add to watchlist" }), _jsx("span", { className: "basketIconBlue", onClick: () => buySellCallBack(true, true), title: "Add to basket" })] }))] })), _jsxs("div", Object.assign({ className: `${styles.sectionContent} mb-5` }, { children: [_jsxs("div", Object.assign({ className: styles.infoPanel }, { children: [_jsxs("div", Object.assign({ className: styles.priceView }, { children: [_jsx(CommonLtpRenderer, { scripCode: scripCode, exch: exch, exchType: exchType, renderElement: commonLtpRenderCallBack, ltp: lastRate, prevLtp: prevClose, componentName: componentName }), _jsx("div", Object.assign({ className: `mediumWeight small ${styles.expiry}` }, { children: getDefaultDateFormat(date) }))] })), _jsxs("div", Object.assign({ className: styles.purchaseView }, { children: [_jsx(BuyButton, { onClick: () => buySellCallBack(true, false) }), _jsx(SellButton, { onClick: () => buySellCallBack(false, false) })] }))] })), _jsxs("div", Object.assign({ className: styles.viewDataPanel }, { children: [_jsxs("div", Object.assign({ className: "marketLimitBtn d-flex" }, { children: [_jsx("span", Object.assign({ onClick: () => {
                                                    toogleDataChart(false, "data");
                                                }, className: `${infoType === "data" ? "active mediumWeight" : ""}` }, { children: "Data" })), showIframe && (_jsx("span", Object.assign({ onClick: () => {
                                                    toogleDataChart(true, "chart");
                                                }, className: `${infoType === "chart" ? "active mediumWeight" : ""}` }, { children: "Chart" })))] })), infoType === "data" && (_jsx(OverviewDetails, { id: id, name: name, spotToken: spotToken, scripCode: scripCode, symbol: symbol, expiry: expiry, exch: exch, exchType: exchType, indicatorWidgetSymbol: indicatorWidgetSymbol, indexPCR: indexPCR }))] })), showIframe &&
                                infoType === "chart" &&
                                (iframeLoader ? (_jsx(Loader, {})) : iframeError ? (_jsx(Backfill, { errorMessage: "No Data Found!", hideImg: true })) : (_jsx("div", Object.assign({ className: styles.iframeScrollHandle }, { children: _jsx("iframe", { src: getUrl(), width: "100%", loading: "lazy", height: 200, className: styles.iframePanel, title: "nifty and banknifty chart" }) }))))] })), indicatorWidgetSymbol && indicatorWidgetSymbol !== "" && (_jsx(IndicatorWidget, { id: id, symbol: indicatorWidgetSymbol.toUpperCase() }))] })) })) })));
});
Overview.displayName = "Overview";
export default Overview;
